import { render } from "./AssignTenant.vue?vue&type=template&id=7cacadc3&scoped=true"
import script from "./AssignTenant.vue?vue&type=script&lang=js"
export * from "./AssignTenant.vue?vue&type=script&lang=js"

import "./AssignTenant.vue?vue&type=style&index=0&id=7cacadc3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cacadc3"]])

export default __exports__